import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: '/', name: 'Home', component: () => import('../views/Home.vue') },
  { path: '/about', name: 'About', component: () => import('../views/About.vue') },
  { path: '/equipments', name: 'Equipments', component: () => import('../views/Equipments.vue') },
  { path: '/equipment/:id', name: 'EquipmentDetail', component: () => import('../views/EquipmentDetail.vue') },
  { path: '/products', name: 'Products', component: () => import('../views/Products.vue') },
  { path: '/factory', name: 'Factory', component: () => import('../views/Factory.vue') },
  { path: '/projects', name: 'Projects', component: () => import('../views/Projects.vue') },
  { path: '/news', name: 'News', component: () => import('../views/News.vue') },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

// 每次页面切换自动上报访问记录
router.afterEach((to, from) => {
  fetch('/api/track', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      page: to.fullPath,
      referrer: from?.fullPath || document.referrer,
    }),
    keepalive: true,
  }).catch(() => {})
})

export default router
